export const state = {
  titletext: "",
};
export const getters = {};

export const actions = {
  newTitle({ commit }, titlemessage) {
    commit("SET_TITLE", titlemessage);
  },
  clearTitle({ commit }) {
    commit("CLEAR_TITLE");
  },
};

export const mutations = {
  SET_TITLE(state, titlemessage) {
    state.titletext = titlemessage;
  },
  CLEAR_TITLE(state) {
    state.titletext = "";
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
